<template>
    <loading name='load user registration'>
        <div class="container user-events fix-footer">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card mt-5">
                        <div class="card-header">
                            <h3>{{ $t('pages.UserEvents') }}</h3>
                        </div>
                        <div class="card-body">
                            <div class="row" v-if="userEventRegistrations && userEventRegistrations.length">
                                <div class="col-12 event-item" v-for="event in userEventRegistrations"
                                     :key="'event-id-'+event.event_id">
                                    <h4>{{event.name}}
                                        <a class="fas fa-qrcode float-right hand" :href="api+`/secure/user/events/${event.event_id}/qr?token=${token}`" target="_blank" v-if="event.subscribed"></a>
                                        <edit-user-event-modal  class="float-right mr-3" v-if="event.subscribed && canEdit(event.event_id)"
                                                                :note="event.note"
                                                                :event-id="event.event_id"
                                                                :transport-in="event.transport_in"
                                                                :transport-out="event.transport_out"
                                        />
                                    </h4>
                                    <div><strong>{{$t('fields.Theme')}}:</strong> {{event.theme}}</div>
                                    <small><strong>{{$t('fields.FromTo')}}:</strong> {{event.start_date}} - {{event.end_date}}</small>
                                    <hr>
                                    <div class="event-body row" v-if="event.subscribed">
                                        <div class="col col-md-6" v-if="event.transport_in != null && event.transport_in !== ''">
                                            <label>{{$t('fields.transportIn')}}</label>
                                            <div class="mb-2">
                                                {{parseTransportType(event.transport_in)}}
                                            </div>
                                        </div>
                                        <div class="col col-md-6" v-if="event.transport_out != null && event.transport_out !== ''">
                                            <label>{{$t('fields.transportOut')}}</label>
                                            <div class="mb-2">
                                                {{parseTransportType(event.transport_out)}}
                                            </div>
                                        </div>
                                        <div class="col col-md-6">
                                            <label>{{$t('fields.NeedPay')}}</label>
                                            <div class="mb-2">
                                                {{event.need_pay}} &euro;
                                            </div>
                                        </div>
                                        <div class="col col-md-6">
                                            <label>{{$t('fields.Paid')}}</label>
                                            <div class="mb-2">
                                                {{event.paid}} &euro;
                                            </div>
                                        </div>
                                        <div class="col col-md-6">
                                            <label>{{$t('fields.PaymentNumber')}}</label>
                                            <div class="mb-2">
                                                {{event.payment_number}}
                                            </div>
                                        </div>
                                        <div class="col col-md-6">
                                            <label>{{$t('fields.registeredAs')}}</label>
                                            <div v-if="event && event.volunteer_type_id" class="mb-2">
                                                {{$t('fields.volunteerType')}}: {{volunteerType(event.volunteer_type_id)}}
                                            </div>
                                            <div v-else class="mb-2">{{$t('fields.Participant')}}</div>
                                        </div>
                                        <div class="col" v-if="event.note">
                                            <label>{{$t('fields.Note')}}</label>
                                            <div class="mb-2" v-html="event.note"></div>
                                        </div>
                                    </div>
                                    <div class="text-center" v-else>
                                        <p>{{$t('userEvent.unsubscribed')}}</p>
                                    </div>
                                    <div class="mt-3 text-center" v-if="canEdit(event.event_id)">
                                        <button class="btn btn-primary" @click="() => changeSubs(event)">{{btnText(event)}}</button>
                                        <hr class="pb-3"/>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-center">
                                <h4>Momentalne niesi nikde registrovaný <h2 class="far fa-frown primary-color"></h2></h4>
                                <router-link class="btn btn-primary" to="/user/events" v-if="availableEvents.length && canRegister()">Registrovať</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import find from 'lodash/find';
  import dayjs from 'dayjs';
  import {can_register} from "../../utils/user";
  import {API_ROOT} from '../../constants';
  import EditUserEventModal from '../../components/userEvent/EditUserEventModal.vue';
  import { TRANSPORT_OPTIONS } from '../../constants/eventContant';

  export default {
    name: 'EventRegistrations',
    components: {EditUserEventModal},
    created() {
      this.$wait.start('load user registration');
      const types = this.loadVolunteerTypes();
      const events = this.userEvents();

      Promise.all([types, events])
        .then(() => {
          this.$wait.end('load user registration');
        });
    },
    methods: {
      ...mapActions(['userEvents', 'loadVolunteerTypes', 'subscribeEvent', 'unsubscribeEvent']),
      volunteerType(typeId) {
        const volunteerType = find(this.getVolunteerTypes, {id: typeId});
        return volunteerType ? volunteerType.name : '';
      },
      btnText(event) {
        return event.subscribed ? this.$t('button.Unsubscribe') : this.$t('button.Subscribe')
      },
      changeSubs(event) {
        const args = {
          eventId: event.event_id
        };
        let promise = null;

        this.$wait.start('load user registration');
        if (event.subscribed) {
          promise = this.unsubscribeEvent(args)
        } else {
          promise = this.subscribeEvent(args)
        }

        promise.then(() => {
          this.userEvents().then(() => {
            this.$wait.end('load user registration');
          });
        });
      },
      parseTransportType(transport) {
        const transportType = find(TRANSPORT_OPTIONS, {value: transport});
        return transportType ? transportType.label : this.$t('transportTypes.Bus') + ': ' +  transport;
      },
      canEdit(event_id) {
        const event = find(this.$store.state.home.availableEvents, { id: event_id });
        return event ? dayjs(event.start_date).subtract(1, 'day').isAfter(dayjs()) : false;
      },
      canRegister() {
        return can_register(this.user);
      }
    },
    computed: {
      ...mapGetters(['userEventRegistrations', 'getVolunteerTypes', 'token', 'availableEvents', 'user']),
      api() {
        return API_ROOT
      }
    }
  };
</script>
